export enum MaterialType{
    Basic='Basic',
    Standard='Standard',
    Normal='Normal',
    Lambert='Lambert',
    Phong='Phone',
    Physical='Physical',
    Toon='Toon',
  }

export enum EventType{
    ClickL='clickL',
    ClickR='clickR',
    DbClick='dbClick',
    MoveIn='moveIn',
    MoveOut='moveOut',
    Chang='chang',
    StartAnimation='startAnimation',
    StopAnimation='stopAnimation',
}

export enum ActionType{
    OpenUrl='openUrl',
    OpenAction='openAction',  // 开始动画
    StopAction='stopAction', //停止动画动画
    ChangeProperty='changeProperty',  // 改变模型属性
    TwinOper='twinOper',        // 孪生操作
    ChangeView='changeView',    // 改变视角
    FocusObject='focusObject',  //聚焦到物体
    HighlightObject='highlightObject',  // 高亮模型
    NoHighlightObject='noHighlightObject',  // 取消高亮模型
}
export enum TwinType{
    MQTT='MQTT',
    WebSocket='WebSocket',
}

export enum PandaMode{
    Edit='edit',
    Run='run'
  }


export enum VIEWPOINT{
    DEFAULT='default',
    TOP='top',
    BOTTOM='bottom',
    LEFT='left',
    RIGHT='right',
    FRONT='front',
    BACK='back',
}